import { render } from "./LeaderboardKeySelector.vue?vue&type=template&id=37c6f684&ts=true"
import script from "./LeaderboardKeySelector.vue?vue&type=script&lang=ts"
export * from "./LeaderboardKeySelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__